import parsePhoneNumber, { PhoneNumber } from 'libphonenumber-js';

interface CleanPhoneNumber {
	(number: string, defaultCountry?: string): string;
}

const formatPhoneNumberForDesign: CleanPhoneNumber = number => {
	if (!number) return '';

	const phoneNumber = parsePhoneNumber(`+${number.replace(/^\+/, '')}`);

	if (phoneNumber) {
		if (number.length === 10) {
			return `${number.substring(0, 3)} ${number.substring(3, 6)} ${number.substring(6, 10)}`;
		}
		return phoneNumber.formatNational();
	} else {
		return number.replace(/[^0-9+]/g, '');
	}
};

export default formatPhoneNumberForDesign;
